// Veeransh Admin — cool slate text tint (DESIGN.md text-primary #1A2332)
const lightColor = "26, 35, 50";
const darkColor = "231, 227, 252";

export const customColors = {
  main: (mode) => (mode === "light" ? lightColor : darkColor),
  dark: darkColor,
  light: lightColor,
};

const DefaultPalette = (mode, skin, themeColor) => {
  const mainColor = mode === "light" ? lightColor : darkColor;

  const primaryGradient = () => {
    if (themeColor === "primary") {
      return "#4A6B8A";
    } else if (themeColor === "secondary") {
      return "#6B8499";
    } else if (themeColor === "success") {
      return "#4CB200";
    } else if (themeColor === "error") {
      return "#E04347";
    } else if (themeColor === "warning") {
      return "#D4A017";
    } else {
      return "#4A6B8A";
    }
  };

  const defaultBgColor = () => {
    if (skin === "bordered" && mode === "light") {
      return "#FFFFFF";
    } else if (skin === "bordered" && mode === "dark") {
      return "#1A2332";
    } else if (mode === "light") {
      return "#F4F6F9";
    } else {
      return "#1A2332";
    }
  };

  return {
    customColors: {
      darkBg: "#1A2332",
      lightBg: "#F4F6F9",
      primaryGradient: primaryGradient(),
      bodyBg: mode === "light" ? "#F4F6F9" : "#1A2332",
      tableHeaderBg: mode === "light" ? "#F0F2F5" : "#243041",
      navActiveBg: mode === "light" ? "#E8EEF5" : "#243041",
      border: mode === "light" ? "#E2E6ED" : "#3D4A5C",
    },
    common: {
      black: "#1A2332",
      white: "#FCFCFD",
    },
    mode: mode,

    primary: {
      light: "#4A6B8A",
      main: "#1E3A5F",
      dark: "#172E4D",
      contrastText: "#FCFCFD",
    },

    secondary: {
      light: "#6B8499",
      main: "#4A6B8A",
      dark: "#3A5670",
      contrastText: "#FCFCFD",
    },

    success: {
      light: "#4CAF6A",
      main: "#2E7D4F",
      dark: "#25663F",
      contrastText: "#FCFCFD",
    },

    error: {
      light: "#D45C52",
      main: "#C0392B",
      dark: "#A33226",
      contrastText: "#FCFCFD",
    },

    warning: {
      light: "#D4A84A",
      main: "#B8860B",
      dark: "#946E09",
      contrastText: "#1A2332",
    },

    info: {
      light: "#4A8BC4",
      main: "#2B6CB0",
      dark: "#235A94",
      contrastText: "#FCFCFD",
    },

    grey: {
      50: "#F7F8FA",
      100: "#F0F2F5",
      200: "#E2E6ED",
      300: "#C8CFDA",
      400: "#9AA5B4",
      500: "#7A8798",
      600: "#5C6778",
      700: "#45505F",
      800: "#2E3744",
      900: "#1A2332",
      A100: "#E2E6ED",
      A200: "#C8CFDA",
      A400: "#5C6778",
      A700: "#2E3744",
    },

    neutral: {
      90: "#1A2332",
      80: "#2E3744",
      70: "#45505F",
      60: "#5C6778",
      50: "#7A8798",
      40: "#9AA5B4",
      30: "#C8CFDA",
      20: "#E8EEF5",
      10: "#F4F6F9",
    },
    text: {
      primary: `rgba(${mainColor}, 0.92)`,
      secondary: `rgba(${mainColor}, 0.68)`,
      disabled: `rgba(${mainColor}, 0.38)`,
    },
    divider: `rgba(${mainColor}, 0.12)`,
    background: {
      paper: mode === "light" ? "#FFFFFF" : "#243041",
      default: defaultBgColor(),
    },
    action: {
      active: `rgba(${mainColor}, 0.54)`,
      hover: `rgba(${mainColor}, 0.04)`,
      selected: `rgba(30, 58, 95, 0.08)`,
      disabled: `rgba(${mainColor}, 0.3)`,
      disabledBackground: `rgba(${mainColor}, 0.12)`,
      focus: `rgba(30, 58, 95, 0.12)`,
    },
  };
};

export default DefaultPalette;
